import { FunctionComponent } from 'react';

interface CreateKidDocumentStepperProps {
  currentStep: number;
  steps: string[];
}

const CreateKidDocumentStepper: FunctionComponent<
  CreateKidDocumentStepperProps
> = ({ currentStep, steps }) => {
  return (
    <ol className="mb-4 flex w-full items-center border-b border-dashed border-gray-200 pb-2 lg:min-w-[800px]">
      {steps.map((label, idx) => {
        const active = idx === currentStep;
        const complete = idx < currentStep;
        return (
          <li key={label} className="flex flex-1 items-center">
            <div className="flex flex-1 items-center justify-center gap-2">
              <div
                className={
                  'flex aspect-square h-6 w-6 items-center justify-center rounded-full text-xs font-bold ' +
                  (active
                    ? 'bg-mainblue text-white'
                    : complete
                      ? 'bg-green-600 text-white'
                      : 'bg-gray-200 text-gray-700')
                }
              >
                {idx + 1}
              </div>
              <span
                className={
                  'whitespace-nowrap text-sm ' +
                  (active ? 'font-semibold text-mainblue' : 'text-gray-600')
                }
              >
                {label}
              </span>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default CreateKidDocumentStepper;
